class ProductSelector extends HTMLElement {
  constructor() {
    super();

      this.form = document.querySelector(
    `form#${this.getAttribute('data-form-id')}`,
  );
  if (this.form && !this.form.dataset.submitBound) {
    this.form.dataset.submitBound = '1';
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }
   // this.form = document.querySelector(
   //   `form#${this.getAttribute('data-form-id')}`,
   // );
   // this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.form?.elements['add'];
    this.cartDrawer = document.querySelector('cart-drawer');
    this.variants = JSON.parse(
      this.querySelector('[data-variants-json][type="application/json"]')
        .textContent,
    );
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.unavailableText = ` - ${this.dataset.unavailableText}`;
    this.addToCart = this.dataset.addToCart || window.variantStrings.addToBag;
  }

  connectedCallback() {
    this.updateOptions();
    this.filterOptions();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('disabled');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append(
      'sections',
      this.cartDrawer.getSectionsToRender().map((section) => section.section),
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        document.dispatchEvent(new Event('cart-drawer:add'));

        this.submitButton.classList.remove('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper || !errorMessage) return;

    window.dispatchEvent(
      new CustomEvent('formError', { detail: errorMessage }),
    );
    errorWrapper.classList.toggle('hidden', !errorMessage);

    if (typeof errorMessage == 'string') {
      errorWrapper.textContent = errorMessage || '';
    }
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    this.updateOptions();
    this.updateVariant();
    this.toggleAddButton(false, '');
    this.handleErrorMessage();
    this.filterOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateVariantInput();
  }

  updateOptions() {
    let selectedOptions = [];
    const optionsGroups = this.querySelectorAll('fieldset');

    if (optionsGroups) {
      optionsGroups.forEach((optionGroup) => {
        let selectedOption = optionGroup.querySelector(
          'input[type="radio"]:checked',
        );

        if (!selectedOption) {
          selectedOption = optionGroup.querySelector('input[type="radio"]');
        }

        selectedOptions.push(selectedOption);
      });

      this.querySelectorAll('select').forEach((select) =>
        selectedOptions.push(select),
      );
    } else {
      selectedOptions = this.querySelectorAll(
        'input[type="radio"]:checked, select',
      );
    }

    this.options = Array.from(selectedOptions, (el) => ({
      name: el.dataset.name,
      value: el.value,
    }));
  }

  updateVariant() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index].value === option)
        .includes(false);
    });
  }

  updateVariantInput() {
    const input = this.querySelector('[name="id"]');
    input.value = this.currentVariant.id;
  }

  setUnavailable() {
    const price = this.querySelector(`#price-${this.dataset.sectionId}`);

    if (!this.submitButton) return;
    this.submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visually-hidden');
  }

  toggleAddButton(disable, text) {
    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled');
      if (text) this.submitButton.textContent = text;
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButton.textContent = this.addToCart;
    }
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destinationPrice = document.querySelector(
          `#price-${this.dataset.sectionId}`,
        );
        const sourcePrice = html.querySelector(
          `#price-${this.dataset.sectionId}`,
        );

        if (destinationPrice && sourcePrice) {
          destinationPrice.classList.remove('visibility-hidden');
          destinationPrice.innerHTML = sourcePrice.innerHTML;
        }
      });
  }

  /**
   * Filter unavailable options.
   */
  filterOptions() {
    for (const [key, { name }] of this.options.entries()) {
      this.querySelectorAll(`[data-name="${name}"]`).forEach((swatch) => {
        const selectOptions = swatch.querySelectorAll('option');
        if (selectOptions.length) {
          return selectOptions.forEach((option) => {
            if (this.isOptionAvailable(key, option.value)) {
              return (option.innerHTML = option.innerHTML.replace(
                this.unavailableText,
                '',
              ));
            }

            if (option.innerHTML.includes(this.unavailableText)) return;

            option.innerHTML = `${option.innerHTML}${this.unavailableText}`;
          });
        }

        return swatch.classList.toggle(
          'is-unavailable',
          !this.isOptionAvailable(key, swatch.value),
        );
      });
    }
  }

  /**
   * Check if at least one available variant that contains this option exists.
   *
   * @param {Number} index
   * @param {String} value
   * @returns {Boolean}
   */
  isOptionAvailable(index, value) {
    return this.variants.some((variant) => {
      if (!variant.available) return false;

      const valuesToCheck = {};
      for (let i = 0; i < index; i++) {
        const optionHandle = `option${i + 1}`;
        const optionValue = this.options[i].value;
        valuesToCheck[optionHandle] = optionValue;
      }
      const currentHandle = `option${index + 1}`;
      valuesToCheck[currentHandle] = value;
      return Object.entries(valuesToCheck).every(
        ([handle, value]) => variant[handle] === value,
      );
    });
  }
}

customElements.define('product-selector', ProductSelector);
